export enum EventTypes {
  CheckedIn = 'Checked In',
  SMSConfirmationSent = 'SMS Confirmation Sent',
  ConsultationSMS1Sent = 'Consultation SMS 1 Sent',
  ConsultationSMS2Sent = 'Consultation SMS 2 Sent',
  VetServicesStarted = 'Vet Services Started',
  CheckedOut = 'Checked Out',
  Consultation = 'Consultation',
  InProgressStarted = 'In Progress Started',
  Admitted = 'Admitted',
  FinalizeStarted = 'Finalize Started',
  PaidStarted = 'Paid Started',
  EnteredVisitAdminMode = 'Entered Visit Admin Mode',
  ExitedVisitAdminMode = 'Exited Visit Admin Mode',
}

export enum EventTypesNumeric {
  CheckedIn = 1,
  SMSConfirmationSent = 2,
  ConsultationSMS1Sent = 3,
  ConsultationSMS2Sent = 4,
  VetServicesStarted = 5,
  CheckedOut = 6,
  Consultation = 7,
  InProgressStarted = 8,
  Admitted = 9,
  FinalizeStarted = 10,
  PaidStarted = 11,
  EnteredVisitAdminMode = 12,
  ExitedVisitAdminMode = 13,
  FinalizeCompleted = 14,
  AttendingDoctorChanged = 15,
}
